import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/services/rtkQuery/axiosBaseQuery';
import { getAssetsPackageQuery } from './queries';
export var assetsPackageApi = createApi({
  reducerPath: 'assetsPackageQuery',
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 5,
  tagTypes: ['AssetsPackage'],
  endpoints: function endpoints(builder) {
    return {
      getAssetsPackage: builder.query(getAssetsPackageQuery)
    };
  }
});
var useGetAssetsPackageQuery = assetsPackageApi.useGetAssetsPackageQuery;
export { useGetAssetsPackageQuery };
var getAssetsPackage = assetsPackageApi.endpoints.getAssetsPackage,
    assetsPackageReducerPath = assetsPackageApi.reducerPath,
    assetsPackageQueryReducer = assetsPackageApi.reducer,
    assetsPackageMiddleware = assetsPackageApi.middleware;
export { assetsPackageReducerPath, assetsPackageQueryReducer, assetsPackageMiddleware, getAssetsPackage };